import PropTypes from 'prop-types';
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import ArrowBack from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles({
  appBar: {
    root: {
      width: 300,
    },
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    marginLeft: 10,
  },
});

const LeftBarHeader = ({ handleToggleLeftBar, title, icon = null }) => {
  const classes = useStyles();

  return (
    <AppBar position="relative" className={classes.appBar}>
      <Toolbar variant="dense">
        <div onClick={() => handleToggleLeftBar()}>
          <IconButton edge="start" color="inherit">
            <ArrowBack />
          </IconButton>
        </div>

        <div className={classes.grow} />

        {icon}
        <Typography variant="subtitle1" className={classes.title}>{title}</Typography>
      </Toolbar>
    </AppBar>
  );
};

LeftBarHeader.propTypes = {
  handleToggleLeftBar: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  icon: PropTypes.node,
};

export default LeftBarHeader;
